import { LicensingContext, Logger, SessionContext } from "@viamap/viamap2-common"
import { useContext, useEffect } from "react";
import { actionUpdateAvailableFeatures, ApplicationStateContext } from "../states/ApplicationState";

/** This componennt is added to application three at places where ither user session or license may change. This component forces a refresh of access rights. 
 * ToDo: Move to viamap2-common
*/
export const AccessRightsUpdater = (props: { children: any }) => {
   const { state: sessionState } = useContext(SessionContext);
   const { state: licensingState } = useContext(LicensingContext);
   const { dispatch: applicationStateDispatch } = useContext(ApplicationStateContext);

   useEffect(() => {
      applicationStateDispatch(actionUpdateAvailableFeatures(sessionState.userRoles, licensingState?.currentlicense));
      Logger.initialize(licensingState.product, sessionState.userRef, sessionState.userName);
   }, [sessionState.userRoles, licensingState.currentlicense]);

   return (
      <>
         {props.children}
      </>
   );
}